
export function formatPrice(rial?: number) {
    if (rial === undefined) return "___";
    const toman = Math.floor(rial / 10);
    return toman.toLocaleString("fa-IR");
}

export const dateTime = (dateTime?: string): string => {
    if (!dateTime) return 'نامشخص';
    const date = new Date(dateTime);
    const options: Intl.DateTimeFormatOptions = {
        timeZone: 'Asia/Tehran',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    };

    return new Intl.DateTimeFormat('fa-IR', options).format(date);
}